import { GridLoader } from 'react-spinners';
import styles from './styles/styles.module.css';

const FullPageLoader = () => {
  return (
    <div className={styles.wrapper}>
      <GridLoader size={20} />
    </div>
  );
};

export default FullPageLoader;
